module.exports = __webpack_public_path__ + "static/img/img_4.7639b29a.jpg";